import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { concat, forkJoin, Observable } from "rxjs";
import { catchError, last, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import {
  DistributionList,
  DistributionListUser,
} from "../model/distributionList";
import { Lista } from "../model/lista";
import { SaveDevicesInList } from "../model/saveDevicesInList";
import { UpdateDistributionList } from "../model/updateDistributionList";

@Injectable({
  providedIn: "root",
})
export class DistributionListService {
  url = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // ------------------------------------- DistributionList ------------------------------------- //

  getDistributionLists(): Observable<Lista[]> {
    return this.http.get<Lista[]>(`${this.url}/v4/uop/distlists`);
  }

  getDevicesOfList(id: string): Observable<String[]> {
    return this.http.get<String[]>(
      `${this.url}/v4/uop/distlists/devcode/${id}`
    );
  }

  deviceValidation(deviceCode: String): Observable<DistributionList[]> {
    return this.http.get<DistributionList[]>(
      `${this.url}/v4/uop/device/${deviceCode}`
    );
  }

  getDistributionList(id: string): Observable<DistributionList> {
    return this.http.get<DistributionList>(
      `${this.url}/distribution/getDistributionList`,
      {
        params: { distributionId: id },
      }
    );
  }
  /*testUpdate(){
    let newDistributionList:UpdateDistributionList = new UpdateDistributionList();
    newDistributionList.name = "name";
    newDistributionList.devCodeList.push("FFFFFFFF");
    this.http.put<any>(`${environment.baseUrl}/v4/uop/distlists/devcode/86`,newDistributionList, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')//x-www-form-urlencoded
    }).pipe(
      catchError( (err)=>{
        throw err;
      } ));
  }*/

  getDistributionListBySender(
    senderId: string
  ): Observable<DistributionList[]> {
    return this.http.get<DistributionList[]>(
      `${this.url}/v4/uop/distlists/${senderId}`,
      {
        params: { senderId: senderId },
      }
    );
  }

  createDistributionList(distributionList: any) {
    return this.http.post(`${this.url}/v4/uop/distlists`, distributionList);
  }

  updateDistributionList(idList: string, name: string, newDevices: string[]) {
    let newDistributionList: UpdateDistributionList =
      new UpdateDistributionList();
    newDistributionList.name = name;
    newDistributionList.devCodeList = newDevices;
    return this.http
      .put<any>(
        `${environment.baseUrl}/v4/uop/distlists/${idList}`,
        newDistributionList,
        {
          headers: new HttpHeaders().set("Content-Type", "application/json"), //x-www-form-urlencoded
        }
      )
      .pipe(
        catchError((err) => {
          throw err;
        })
      );
  }

  modifyDistributionList(
    listId: string,
    name: string,
    oldDevices: string[],
    newDevices: string[]
  ) {
    return this.updateDistributionList(listId, name, newDevices);
  }
  ////////////////////////////

  deleteDistributionList(listId: string): Observable<any> {
    // return this.http.delete(`${this.url}/v4/uop/distlists/${listId}`);
    return this.http.delete(
      `${environment.baseUrl}/v4/uop/distlists/${listId}`
    );
  }

  // ------------------------------------- DistributionListUser ------------------------------------- //

  getDistributionListUsers(listId: string): Observable<DistributionListUser[]> {
    return this.http.get<DistributionListUser[]>(
      `${this.url}/distribution/getDistributionListUsers`,
      {
        params: { listId: listId },
      }
    );
  }

  getDistributionListUser(userId: string): Observable<DistributionListUser> {
    return this.http.get<DistributionListUser>(
      `${this.url}/distribution/getDistributionListUser`,
      {
        params: { userId: userId },
      }
    );
  }

  createDistributionListUser(distributionListUser: DistributionListUser) {
    return this.http.post(
      `${this.url}/distribution/createDistributionListUser`,
      distributionListUser
    );
  }

  updateDistributionListUser(distributionListUser: DistributionListUser) {
    return this.http.put(
      `${this.url}/distribution/updateDistributionListUser`,
      distributionListUser
    );
  }

  deleteDistributionListUser(distributionListUser: DistributionListUser) {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: distributionListUser,
    };
    return this.http.delete(
      `${this.url}/distribution/deleteDistributionListUser`,
      options
    );
  }
}
